module.exports = __webpack_public_path__ + "img/about_title1.da1ea23a.png";